fragment FieldFragment on FormField {
    id
    type
    label
    placeholder
    styles
    subfields
    isSeparateFields
    defaultValues
    entityName
    fieldName
    entityTypes
    isRequired
    isRemovable
    attribute {
        id
        name
        type
    }
    image {
        fileId
        name
        imageUrl
    }
    originalFieldId
    originalFieldApiId
    rules {
        answerChoice {
            id
            name
        }
        objectsToAssign {
            ... on Tag {
                id
                name
            }
            ... on Audience {
                id
                name
            }
            ... on Product {
                id
                name
            }
            ... on Source {
                id
                name
            }
            ... on Stageset {
                id
                name
            }
        }
    }
}
